<template>
    <VModalWrapper :name="name" :title="title" v-on="listeners" v-bind="attributes">
        <ValidationObserver v-slot="{ handleSubmit }" v-if="itemId">
            <form class="active-form" @submit.prevent="handleSubmit(submit)">
                <!-- КОМУ. Сначала вид держателя, потом сам держатель: списки сотрудников
                     и записей справочника разные, и один общий список из тысячи строк
                     вперемешку читать невозможно. -->
                <ValidationProvider
                    class="active-form__field"
                    name="action-holder-kind"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <label class="active-form__label active-form__label_required" for="action-holder-kind">
                        Кому
                    </label>

                    <VSelect
                        id="action-holder-kind"
                        name="action-holder-kind"
                        label="label"
                        class="active-form__control control"
                        placeholder="Вид держателя"
                        :clearable="false"
                        :searchable="false"
                        :disabled="isSaving"
                        :options="holderKindOptions"
                        :reduce="(option) => option.value"
                        v-model="holderType"
                    />

                    <span class="active-form__error">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider
                    class="active-form__field"
                    name="action-holder"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <label class="active-form__label active-form__label_required" for="action-holder">
                        {{ holderLabel }}
                    </label>

                    <VSelect
                        id="action-holder"
                        name="action-holder"
                        label="label"
                        class="active-form__control control"
                        placeholder="Выберите держателя"
                        :clearable="false"
                        :disabled="isSaving"
                        :options="holderOptions"
                        :reduce="(option) => option.value"
                        v-model="holderId"
                    />

                    <span class="active-form__error">{{ errors[0] }}</span>
                </ValidationProvider>

                <!-- СРОК ВОЗВРАТА — обещание этой передачи, и вводится вместе с ней: другого
                     места для него нет. По нему работает фильтр «просрочен возврат». -->
                <div class="active-form__field">
                    <label class="active-form__label" for="action-holder-until">Вернуть до</label>

                    <input
                        id="action-holder-until"
                        name="action-holder-until"
                        class="active-form__control control"
                        type="date"
                        :disabled="isSaving"
                        v-model="holderUntilAt"
                    />
                </div>

                <!-- Комментарий необязателен намеренно: обязательное поле «причина»
                     заполняют точкой, и польза от него исчезает вместе со смыслом. -->
                <ValidationProvider class="active-form__field" name="action-comment" v-slot="{ errors }">
                    <label class="active-form__label" for="action-comment">Комментарий</label>

                    <VInput
                        id="action-comment"
                        name="action-comment"
                        class="active-form__control"
                        placeholder="Например: выдан под проект до конца года"
                        :disabled="isSaving"
                        v-model="comment"
                    ></VInput>

                    <span class="active-form__error">{{ errors[0] }}</span>
                </ValidationProvider>

                <!-- ОТКАЗ СЕРВЕРА ПОКАЗЫВАЕТСЯ ЗДЕСЬ ЖЕ, а не модалкой поверх модалки:
                     форма остаётся открытой вместе с введённым, и человек видит, что
                     именно поправить. Чаще всего это будет «состояние изменилось» —
                     карточку открыли час назад, и вещь успели выдать. -->
                <p class="active-form__error inventory-action-modal__error" v-if="error">{{ error }}</p>

                <div class="active-form__actions">
                    <VButton
                        type="button"
                        class="active-form__action button_green-light"
                        :disabled="isSaving"
                        @click="hide"
                    >
                        Отмена
                    </VButton>

                    <VButton type="submit" class="active-form__action button_green" :disabled="isSaving">
                        {{ isSaving ? 'Сохраняем…' : submitTitle }}
                    </VButton>
                </div>
            </form>
        </ValidationObserver>
    </VModalWrapper>
</template>
<script>
// Components
import VInput from '../../../components/VInput/VInput.vue';
import VButton from '../../../components/VButton/VButton.vue';
import VSelect from '../../../components/VSelect/VSelect.vue';
import VModalWrapper from '../../../components/VModalWrapper/VModalWrapper.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

// Other
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import ModalNames from '../../../../js/enums/ModalNames';
import ModalMixin from '../../../../js/vue/mixins/ModalMixin';
import InventoryHolderTypeTitle from '../../../../js/enums/InventoryHolderTypeTitle';
import { ACTION_CHANGE_HOLDER, ACTION_ISSUE } from '../../../../js/inventoryActions';
import { changeInventoryItemOwner, issueInventoryItem } from '../../../../js/inventory-api';
import { errorMessage } from '../../../../js/error';

/**
 * Вид держателя. Значения — App\Enums\InventoryOwnerType, их же ждёт бэкенд.
 */
const HOLDER_EMPLOYEE = 'employee';
const HOLDER_EXTERNAL = 'external';

/**
 * Передача оборудования держателю: «Выдать» и «Сменить владельца» (7-F2A).
 *
 * ОДНО ОКНО НА ДВА ДЕЙСТВИЯ, И ЭТО НЕ «УНИВЕРСАЛЬНАЯ МОДАЛКА». Форма у них буквально
 * одна и та же — кому передаём и почему; различаются они тем, что происходит на сервере,
 * и это различие выражено не полем внутри формы, а разными маршрутами. Развести их
 * по двум файлам значило бы получить две копии одного списка держателей, которые
 * однажды разойдутся. Заголовок, подпись кнопки и маршрут приходят параметрами —
 * человек видит два разных окна, а поддерживается один список.
 *
 * ЗАПРОС ДЕЛАЕТ ОКНО, А НЕ КАРТОЧКА. Иначе отказ сервера приходил бы уже после закрытия,
 * и введённое пропадало бы вместе с формой. Здесь окно остаётся открытым, показывает
 * человеческий текст отказа и даёт исправить — а закрывается только после успеха.
 */
@Component({
    components: {
        VInput,
        VButton,
        VSelect,
        VModalWrapper,

        ValidationObserver,
        ValidationProvider,
    },
})
class VInventoryItemHolderActionModal extends ModalMixin {
    @Prop({ type: String, default: ModalNames.INVENTORY_ITEM_HOLDER_ACTION })
    name;
    @Prop({ type: String, default: 'Передача оборудования' })
    defaultTitle;
    @Prop({ type: Object, required: true })
    cache;

    itemId = null;
    action = ACTION_ISSUE;
    holderType = HOLDER_EMPLOYEE;
    holderId = null;
    holderUntilAt = '';
    comment = '';
    error = '';
    isSaving = false;

    get isIssue() {
        return this.action === ACTION_ISSUE;
    }

    get submitTitle() {
        return this.isIssue ? 'Выдать' : 'Передать';
    }

    get holderKindOptions() {
        return [
            { value: HOLDER_EMPLOYEE, label: 'Сотрудник Талан' },
            { value: HOLDER_EXTERNAL, label: 'Внешний держатель' },
        ];
    }

    get holderLabel() {
        return this.holderType === HOLDER_EMPLOYEE ? 'Сотрудник' : 'Запись справочника';
    }

    /**
     * Список держателей выбранного вида.
     *
     * Погашенные записи справочника сюда не попадают: назначать их нельзя, и сервер
     * откажет. Это тот случай, когда прятать честнее, чем показывать, — в отличие
     * от формы правки, где погашенный держатель уже стоит у предмета и его надо видеть.
     */
    get holderOptions() {
        if (this.holderType === HOLDER_EMPLOYEE) {
            return (this.cache.users ?? []).map((user) => ({ value: user.id, label: user.displayName }));
        }

        return (this.cache.holders ?? [])
            .filter((holder) => holder.active)
            .map((holder) => {
                const type = InventoryHolderTypeTitle[holder.type] ?? holder.type;

                return { value: holder.id, label: `${holder.full_name} — ${type}` };
            });
    }

    /**
     * Смена вида сбрасывает выбранного держателя: номер из чужого списка означал бы
     * ссылку не в ту таблицу, и сервер отверг бы запрос уже после отправки.
     */
    @Watch('holderType')
    onHolderTypeChanged() {
        this.holderId = null;
    }

    async submit() {
        if (this.isSaving || !this.itemId || !this.holderId) {
            return;
        }

        this.isSaving = true;
        this.error = '';

        const payload = {
            holderType: this.holderType,
            holderId: this.holderId,
            holderUntilAt: this.holderUntilAt,
            comment: this.comment,
        };

        try {
            const response = this.isIssue
                ? await issueInventoryItem(this.itemId, payload)
                : await changeInventoryItemOwner(this.itemId, payload);

            // Карточка приезжает в ответе — панели не нужен второй запрос за тем же самым.
            this.resolve(response.data);
            this.hide();
        } catch (requestError) {
            this.error = errorMessage(requestError);
        } finally {
            this.isSaving = false;
        }
    }

    beforeOpen(event) {
        const params = event?.params ?? {};

        this.itemId = params.itemId ?? null;
        this.action = params.action === ACTION_CHANGE_HOLDER ? ACTION_CHANGE_HOLDER : ACTION_ISSUE;

        // Одно окно на две операции, но заголовок у каждой свой — как и кнопка в карточке:
        // «Выдать» открывает выдачу, «Сменить владельца» — смену владельца.
        if (!params.title) {
            this.title = this.isIssue ? 'Выдача оборудования' : 'Смена владельца';
        }

        this.holderType = params.holderType === HOLDER_EXTERNAL ? HOLDER_EXTERNAL : HOLDER_EMPLOYEE;
        this.holderId = null;
        this.holderUntilAt = '';
        this.comment = '';
        this.error = '';
        this.isSaving = false;

        // Выдача резерва приходит с его держателем. Ставится после тика: смена вида
        // выше запускает onHolderTypeChanged, и тот сбросил бы выбор, сделанный сразу.
        if (params.holderId) {
            this.$nextTick(() => {
                this.holderId = params.holderId;
            });
        }
    }

    beforeClose() {
        this.itemId = null;
        this.holderId = null;
        this.holderUntilAt = '';
        this.comment = '';
        this.error = '';
    }
}

export default VInventoryItemHolderActionModal;
</script>
<style lang="scss">
.inventory-action-modal {
    &__error {
        display: block;
        margin: 8px 0 0;
    }

    // Текст-подсказка над формой: короткое объяснение, что произойдёт. Без него
    // «Вернуть» и «Переместить» выглядят как кнопки без последствий.
    &__hint {
        margin: 0 0 16px;
        color: #5f6368;
        font-size: 0.8125rem;
        line-height: 1.4;
    }
}
</style>
